
















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

@Component({})
export default class MemberMemberSubAccountsGrid extends FeedbackComponent {

  @Prop() memberSubAccounts!: any;
  @Prop() accountNumber!: string;

  private columns: GridColumn[] = [];

  mounted() {

    if (this.memberSubAccounts) {
      this.initColumns();
      this.initAccountsRows()
    }
  }



  private initColumns(): void {
    this.columns.push({property: 'fundNum', header: 'MemberSubAccountsGrid.fundNum'})
    this.columns.push({property: 'fundName', header: 'MemberSubAccountsGrid.fundName'})
    this.columns.push({property: 'memberFundAndAccount', header: 'MemberSubAccountsGrid.memberFundAndAccount'})
    this.columns.push({property: 'moneyType', header: 'MemberSubAccountsGrid.moneyType'})
    this.columns.push({property: 'employerName', header: 'MemberSubAccountsGrid.employerName'})
    this.columns.push({property: 'accountBalance', header: 'MemberSubAccountsGrid.accountBalance'})
    this.columns.push({property: 'seniorityStartDate', header: 'MemberSubAccountsGrid.seniorityStartDate'})
    this.columns.push({property: 'seniorityEndDate', header: 'MemberSubAccountsGrid.seniorityEndDate'})
  }



  private initAccountsRows(): void {

    this.$emit('successResults', this.memberSubAccounts)
  }

  onRowClick(row: any) {
  }


};


